const skills = {
  1: [
    {
      title: "HTML",
      level: 4,
    },
    {
      title: "CSS",
      level: 3,
    },
    {
      title: "SASS",
      level: 1,
    },
    {
      title: "JavaScript",
      level: 4,
    },
    {
      title: "TypeScript",
      level: 3,
    },
    {
      title: "Tailwind CSS",
      level: 2,
    },
    {
      title: "React JS",
      level: 4,
    },
    {
      title: "Figma",
      level: 3,
    },
  ],
  2: [
    {
      title: "React Native",
      level: 4,
    },
    {
      title: "Expo",
      level: 4,
    },
    {
      title: "TypeScript",
      level: 3,
    },
    {
      title: "JavaScript",
      level: 4,
    },
    {
      title: "CSS",
      level: 3,
    },
    {
      title: "Redux",
      level: 1,
    },
    {
      title: "Git",
      level: 3,
    },
    {
      title: "Node.js",
      level: 1,
    },
  ],
};

export default skills;
